/**
 * Divide dos números y salva de division por cero, undefined, null, etc.
 * @param dividend Dividendo
 * @param divisor Divisor
 */
export const safeDiv = (dividend: unknown, divisor: unknown): number => {
  if (!divisor || !dividend || isNaN(Number(dividend)) || isNaN(Number(divisor))) {
    return 0;
  } else {
    return Number(dividend) / Number(divisor);
  }
};
